import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FitnessCenterIcon(props: IconProps) {
    return <Icon {...props} iconKey={"fitness_center"}/>
}
